import { render } from "./NpcStage.vue?vue&type=template&id=69808d78&scoped=true"
import script from "./NpcStage.vue?vue&type=script&lang=js"
export * from "./NpcStage.vue?vue&type=script&lang=js"

import "./NpcStage.vue?vue&type=style&index=0&id=69808d78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69808d78"]])

export default __exports__